var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("g-modal", {
    attrs: { "max-width": "600", title: _vm.$t("filters.searching") },
    on: {
      input: function($event) {
        return _vm.$emit("input", false)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }